import type { TAccessControlRules } from '@frontend/components/agromarket/core/access-control'
import { UserPermission, visibleForPermissionsRule } from '@frontend/components/agromarket/core/access-control'
import type { THarvestSaleAccessControlContext } from './types'

export const HARVEST_SALE_ACCESS_CONTROL_LIST = {
  harvestSalePage: {
    lotsPreview: {
      logisticsServiceBanner: visibleForPermissionsRule([UserPermission.ADMIN, UserPermission.AGRARIAN, UserPermission.LOGISTICS_OPERATOR]),
    },
  },
} satisfies Readonly<TAccessControlRules<THarvestSaleAccessControlContext>>
